import { UseVivianElement } from "./use-vivian-element";

// Idempotent registration: importing the loader multiple times (e.g. an
// optician accidentally including the <script> tag twice) must not throw.
if (!customElements.get("use-vivian")) {
  customElements.define("use-vivian", UseVivianElement);
}

export { UseVivianElement };
